import { useMemo } from "react";
import BaseSelectWithOptions from "../../../../../../shared-components/dados-embarque/base-components/BaseSelectWithOptions";

function SelectCatalogoProdutosSituacao({...props}) {
  const list = useMemo(() => [
    {
      id: 'ATIVADO',
      label: 'ATIVADO',
      value: '0',
    },
    {
      id: 'DESATIVADO',
      label: 'DESATIVADO',
      value: '1',
    },
    {
      id: 'RASCUNHO',
      label: 'RASCUNHO',
      value: '2',
    },
  ], []);

  return <BaseSelectWithOptions list={list} {...props} />;
}

export default SelectCatalogoProdutosSituacao;
